import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, TextField, DialogActions, Button } from '@mui/material';
import { inviteManager } from '../services/apiService.ts';
import { useSnackbar } from 'notistack';

interface Props {
  tenantId: number;
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

const InviteDialog: React.FC<Props> = ({ tenantId, open, onClose, onSuccess }) => {
  const [email, setEmail] = useState('');
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [country, setCountry] = useState('');
  const [city, setCity] = useState('');

  const handleInvite = async () => {
    try {
      setLoading(true);
      await inviteManager(tenantId, email.trim(), { firstName:firstName.trim(), lastName:lastName.trim(), country:country.trim(), city:city.trim() });
      enqueueSnackbar('E-mail sent', { variant: 'success' });
      onSuccess();
      onClose();
    } catch (e: any) {
      enqueueSnackbar(e.response?.data?.message || e.message, { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>Invite Manager</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Email"
          type="email"
          fullWidth
          value={email}
          onChange={e => setEmail(e.target.value)}
        />
        <TextField margin="dense" label="First name" fullWidth value={firstName} onChange={e=>setFirstName(e.target.value)} />
        <TextField margin="dense" label="Last name" fullWidth value={lastName} onChange={e=>setLastName(e.target.value)} />
        <TextField margin="dense" label="Country (ISO-2)" fullWidth value={country} onChange={e=>setCountry(e.target.value.toUpperCase())} inputProps={{maxLength:2}} />
        <TextField margin="dense" label="City" fullWidth value={city} onChange={e=>setCity(e.target.value)} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleInvite} disabled={loading || !email}>Invite</Button>
      </DialogActions>
    </Dialog>
  );
};

export default InviteDialog; 